/* unplugin-vue-components disabled */import script from "./pluginIframe.vue?vue&type=script&lang=ts&setup=true"
export * from "./pluginIframe.vue?vue&type=script&lang=ts&setup=true"

import "./pluginIframe.vue?vue&type=style&index=0&id=7f8f653c&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8f653c"]])

export default __exports__